import { cn } from "@/utils/cn"
import { Cursor as MotionCursor } from "motion-plus/react"
import { AnimatePresence } from "motion/react"

type CursorProps = {
  show: boolean
  label: string
  color: "green" | "viola"
}

export function Cursor({ show, label, color }: CursorProps) {
  return (
    <AnimatePresence>
      {show ? (
        <MotionCursor
          follow
          offset={{ x: 10, y: 15 }}
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.5, opacity: 0 }}
          variants={{ exit: { opacity: 0 } }}
          key="tooltip"
        >
          <p
            className={cn(
              "rounded-tr-md rounded-b-md px-4 py-3 text-xs font-bold text-neutral-dark",
              color === "green" && "bg-green-500",
              color === "viola" && "bg-viola-500"
            )}
          >
            {label}
          </p>
        </MotionCursor>
      ) : null}
    </AnimatePresence>
  )
}
